// @ts-strict

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocalStorageService } from '@services/local-storage/local-storage.service';
import { ICampaignFieldData } from '@app/core/services/url-address-config/url-address-config.types';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IvrPpiModalContainerComponent } from '../../ivr-ppi-modal-container.component';
import { SelectConfigInputValue } from './select-configuration-input/select-configuration-input.component';

@Component({
  selector: 'app-select-configuration-container',
  templateUrl: './select-configuration-container.component.html',
  styleUrls: ['./select-configuration-container.component.scss']
})
export class SelectConfigurationContainerComponent implements OnInit {
  @Input() fieldInfo?: ICampaignFieldData;
  @Input() submitted = false;
  @Input() canCreateNumberConfig = false;
  @Output() emitValue = new EventEmitter<SelectConfigInputValue>();

  public label = '';

  constructor(private modalService: NgbModal, private localStorage: LocalStorageService) {}

  get isPPIConfig(): boolean {
    return this.fieldInfo?.type === 'ppi';
  }

  ngOnInit(): void {
    const currentLang = this.localStorage.getPanelLang();
    this.label = this.fieldInfo?.translations?.find(trans => trans.lang === currentLang)?.label || '';
  }

  // Open modal
  open(): void {
    const modalRef = this.modalService.open(IvrPpiModalContainerComponent, {
      size: 'me'
    });
    const component = modalRef.componentInstance as IvrPpiModalContainerComponent;

    component.modalDescriptionName = '';
    component.modalTitle = this.isPPIConfig ? 'view_translations.add_direct_link' : 'view_translations.assign_ivr_number';
    component.modalType = this.isPPIConfig ? 'create_direct_link' : 'assign_number';
    if (this.isPPIConfig) {
      component.campaignData = { id: 6646 };
    }
  }

  getValue(values: SelectConfigInputValue): void {
    this.emitValue.emit(values);
  }
}
